import { render, staticRenderFns } from "./TerminalTeamGame.vue?vue&type=template&id=5e4c19e8&scoped=true&"
import script from "./TerminalTeamGame.vue?vue&type=script&lang=js&"
export * from "./TerminalTeamGame.vue?vue&type=script&lang=js&"
import style0 from "./TerminalTeamGame.vue?vue&type=style&index=0&id=5e4c19e8&scoped=true&lang=scss&"
import style1 from "./TerminalTeamGame.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c19e8",
  null
  
)

export default component.exports